import React, { Component } from 'react';
import { RouteComponentProps } from 'react-router';
import ReactGA from 'react-ga4';
import configuration from '../config/Configuration';

// Google Analytics only runs where it is configured (production): elsewhere nothing is sent
const googleAnalyticsId = configuration.googleAnalyticsId;
if (googleAnalyticsId) {
    ReactGA.initialize(googleAnalyticsId, {
        gaOptions: {},
    });
}
export const withGATracker = (WrappedComponent: any, options = {}) => {
    const trackPage = (page: string) => {
        if (!googleAnalyticsId) {
            return;
        }
        ReactGA.set({
            page,
            ...options,
        });
        ReactGA.send({ hitType: 'pageview', page });
    };

    const HOC = class extends Component<RouteComponentProps> {
        componentDidMount() {
            const page = this.props.location.pathname + this.props.location.search;
            trackPage(page);
        }

        componentDidUpdate(prevProps: RouteComponentProps) {
            const currentPage = prevProps.location.pathname + prevProps.location.search;
            const nextPage = this.props.location.pathname + this.props.location.search;
            if (currentPage !== nextPage) {
                trackPage(nextPage);
            }
        }

        render() {
            return <WrappedComponent {...this.props} />;
        }
    };

    return HOC;
};

class GoogleAnalytics {
    createEvent = (args: GoogleAnalyticsEvent): void => {
        if (googleAnalyticsId) {
            ReactGA.event(args);
        }
    };

    createDefaultEvent = (category: string, action: string, label?: string): void => {
        if (googleAnalyticsId) {
            ReactGA.event({ category, action, label });
        }
    };
}

interface GoogleAnalyticsEvent {
    category: string;
    action: string;
    label?: string;
    value?: number;
    nonInteraction?: boolean;
    transport?: 'beacon' | 'xhr' | 'image';
}

const ga: GoogleAnalytics = new GoogleAnalytics();
export default ga;
